// // src/config/Config.js
 export const BASE_URL = "https://api.learnific.in"; 
 export const IMAGE_URL = "https://learnific.in";

// src/config/Config.js
//  export const BASE_URL = "http://localhost:8000"; 
//  export const IMAGE_URL = "http://localhost:8000";